import { render, staticRenderFns } from "./PrivacyPolicyPage.vue?vue&type=template&id=9837f59e"
import script from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrivacyPolicyPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrivacyPolicyPage.vue?vue&type=style&index=0&id=9837f59e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports